import { FeatureModule } from '@store/features/types';

export const notificationsFeature: FeatureModule = {
  id: 'notifications',
  name: 'Notifications',
  dependencies: [],
  reducers: {}, // No reducers needed as we're using RTK Query
  middleware: [], // RTK Query middleware is already registered at the store level via baseApi
  // No persistence config = defaults to disabled
  // No sync config = defaults to disabled
  setup: store => {
    console.log(`${notificationsFeature.name} feature initialized`);
  },
  cleanup: store => {
    console.log(`${notificationsFeature.name} feature cleaned up`);
  },
};

export function initializeNotificationsFeature() {
  return { feature: notificationsFeature };
}
